import React, {Component} from 'react';

import {Table, Card, Row, Col, Image, Container} from 'react-bootstrap';
import AppversionModal from './AppversionModal';
import './Appversion.css';

class Appversion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editShow: '',
      editData: '',
    };
  }

  componentDidMount = () => {
    this.props.appVrsnList();
  };

  handleView = os => {
    this.setState({
      editShow: true,
      editData: this.props.appversionDtls,
      os: os,
    });
  };

  handleCloseedit = () => {
    this.setState({editShow: false});
  };

  render() {
    const data =
      this.props.appversionDtls && this.props.appversionDtls
        ? this.props.appversionDtls && this.props.appversionDtls
        : null;

    return (
      <div>
        <Card>
          <Card.Header className='tableHeaderRow'>
            <h3>App Version</h3>
          </Card.Header>
          <Card.Body>
            <div>
              <div className="appverContnr">
                {/* <Container> */}

                <div style={{fontWeight: 'bold'}}>
                  API Down:{data !== null && data.apiDown ? ' True' : ' False'}
                </div>

                <Row style={{marginTop: '30px'}}>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <Card.Header style={{backgroundColor: '#63c2de'}}>
                        <h4>
                          Android
                          <span className="appAdroidEdit">
                            <i
                              className="fa fa-edit fa-lg"
                              style={{fontSize: '23px'}}
                              onClick={() => this.handleView('android')}
                            />
                            <AppversionModal
                              show={this.state.editShow}
                              handleClose={this.handleCloseedit}
                              editData={this.state.editData}
                              os={this.state.os}
                              editAppversion={this.props.editAppversion}
                            />
                          </span>
                        </h4>
                      </Card.Header>
                      <Card.Body>
                        <Row className="appVrsnRow1">
                          <Col xs={4} sm={4} md={2} lg={2}>
                            App Type
                          </Col>
                          <Col xs={4} sm={4} md={2} lg={2}>
                            Current Version
                          </Col>
                          <Col xs={4} sm={4} md={2} lg={2}>
                            Minimum Version
                          </Col>
                          <Col xs={4} sm={4} md={3} lg={3}>
                            Chemist Distance
                          </Col>
                          <Col xs={4} sm={4} md={3} lg={3}>
                            Distributor Distance
                          </Col>
                        </Row>
                        <Row className="appVrsnRow2">
                          <Col
                            xs={4}
                            sm={4}
                            md={2}
                            lg={2}
                            className="appVrsnRow2Col"
                          >
                            MedLynx
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={2}
                            lg={2}
                            className="appVrsnRow2Col"
                          >
                            {data !== null && data.andrCurntV}
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={2}
                            lg={2}
                            className="appVrsnRow2Col"
                          >
                            {data !== null && data.andrMinV}
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={3}
                            lg={3}
                            className="appVrsnRow2Col"
                          >
                            {data !== null && data.chemistDist}
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={3}
                            lg={3}
                            className="appVrsnRow2Col"
                          >
                            {data !== null && data.distributorDist}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <Row style={{marginTop: '30px'}}>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Card>
                      <Card.Header style={{backgroundColor: '#63c2de'}}>
                        <h4>
                          iOS
                          <span className="appAdroidEdit">
                            <i
                              className="fa fa-edit fa-lg"
                              style={{fontSize: '23px'}}
                              onClick={() => this.handleView('ios')}
                            />
                            <AppversionModal
                              show={this.state.editShow}
                              handleClose={this.handleCloseedit}
                              editData={this.state.editData}
                              os={this.state.os}
                              editAppversion={this.props.editAppversion}
                            />
                          </span>
                        </h4>
                      </Card.Header>
                      <Card.Body>
                        <Row className="appVrsnRow1">
                          <Col xs={4} sm={4} md={2} lg={2}>
                            App Type
                          </Col>
                          <Col xs={4} sm={4} md={2} lg={2}>
                            Current Version
                          </Col>
                          <Col xs={4} sm={4} md={2} lg={2}>
                            Minimum Version
                          </Col>
                          <Col xs={4} sm={4} md={3} lg={3}>
                            Chemist Distance
                          </Col>
                          <Col xs={4} sm={4} md={3} lg={3}>
                            Distributor Distance
                          </Col>
                        </Row>
                        <Row className="appVrsnRow2">
                          <Col
                            xs={4}
                            sm={4}
                            md={2}
                            lg={2}
                            className="appVrsnRow2Col"
                          >
                            MedLynx
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={2}
                            lg={2}
                            className="appVrsnRow2Col"
                          >
                            {data !== null && data.iosCurntV}
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={2}
                            lg={2}
                            className="appVrsnRow2Col"
                          >
                            {data !== null && data.iosMinV}
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={3}
                            lg={3}
                            className="appVrsnRow2Col"
                          >
                            {data !== null && data.chemistDist}
                          </Col>
                          <Col
                            xs={4}
                            sm={4}
                            md={3}
                            lg={3}
                            className="appVrsnRow2Col"
                          >
                            {data !== null && data.distributorDist}
                          </Col>
                        </Row>
                        {/* <Row className="appVrsnRow2">
                        <Col xs={4} sm={4} md={4} lg={4} className="appVrsnRow2Col">App Name</Col>
                            <Col xs={4} sm={4} md={4} lg={4} className="appVrsnRow2Col">00</Col>
                            <Col xs={4} sm={4} md={4} lg={4} className="appVrsnRow2Col">00</Col>
                        </Row> */}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {/* </Container> */}
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default Appversion;
